var app = angular.module('leonardo');

var PropertyDialogSelector = function(ngDialog, FilterService, PropertyService, $q) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    templateUrl: 'views/templates/widget/property-dialog-selector.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      name: '@',
      filter: '@',
      inline: '=',
      placeholder: '@',
      multiple: '=',
      mode: '@',
      defaultValues: '=?',
      ngChange: '&',
      classes: '@'
    },
    link: function (scope, elem, attrs, ctrl) {
      scope.ngModelCtrl = ctrl[0];
      scope.Form = scope.$parent.Form ? scope.$parent.Form : { '$submitted' : true };

      scope.filterService = FilterService;
      scope.propertyService = PropertyService;

      scope.getClasses = function() {
        return [scope.classes];
      };

      scope.openSelectorDialog = function() {
        if (scope.disabled) return;
        ngDialog.openConfirm({
          template: 'views/templates/dialog/widget/property-selector.html',
          controller: 'PropertyDialogController',
          className:'ngdialog-theme-default ngdialog-property-selector',
          showClose: false,
          data:{
            multiple: scope.multiple
          }
        }).then(function(result) {
          if (result) {
            var promise = null;
            if (!isNull(scope.filter)) {
              if (scope.filter !== 'property') {
                if (angular.isArray(result)) {
                  var properties = [];
                  angular.forEach(result, function(property) {
                    properties.push(property.id ? property.id : property);
                  });
                  if (scope.mode === 'array') {
                    FilterService.setFilter(scope.filter, properties.length > 0 ? properties : undefined);
                  }
                  else {
                    FilterService.setFilter(scope.filter, properties.length > 0 ? properties.join(',') : undefined);
                  }
                }
                else {
                  if (scope.mode === 'array') {
                    FilterService.setFilter(scope.filter, result.id ? [result.id] : [result]);
                  }
                  else {
                    FilterService.setFilter(scope.filter, result.id ? result.id : result);
                  }
                }
              }
              else {
                if (angular.isArray(result)) {
                  promise = FilterService.setProperty(result[0]);
                }
                else {
                  promise = FilterService.setProperty(result);
                }
              }
            }
            if (angular.isArray(result)) {
              if (scope.mode === 'array') {
                scope.property = result.length > 0 ? result : undefined;
              }
              else {
                scope.property = result.length > 0 ? result.join(',') : undefined;
              }
            }
            else {
              if (scope.mode === 'array') {
                scope.property = result.id ? [result.id] : [result];
              }
              else {
                scope.property = result.id ? result.id : result;
              }
            }
            $q.when(promise).then(function () {
              scope.ngChange();
            });
          }
        });
      };

      scope.$watch('property', function(newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          scope.ngModelCtrl.$setViewValue(newValue);
        }
      });

    }
  };
};

var PropertyDialogController = function ($scope, $rootScope, $q, FilterService, AuthDataService,
                                         PortfolioService, PropertyService, PropertyGroupService) {

  $scope.filterService = FilterService;
  $scope.authDataService = AuthDataService;

  $scope.multiple = $scope.ngDialogData.multiple;

  $scope.accounts = [];
  $scope.managers = [];
  $scope.portfolios = [];
  $scope.properties = [];
  $scope.groups = [];

  $scope.filters_by = [{id:'name', name:'By Name'}];

  $scope.filter_by = 'name';

  $scope.loading = false;
  $scope.no_event = false;

  $scope.selectTab = function(tab) {
    $scope.filter_by = tab;
    if (tab === 'portfolio' && FilterService.hasFilter('portfolio_dialog')) {
      if ($scope.showFilter('account') && FilterService.hasFilter('account')) {
        $scope.account = FilterService.getFilter('account');
        $scope.no_event = true;
      }
      if (FilterService.hasFilter('portfolio')) {
        $scope.portfolio = FilterService.getFilter('portfolio');
      }
    }
    else if (tab === 'name') {
      $scope.reset();
    }
  };

  $scope.initManagers = function (account_id) {
    $scope.managers = [];
    if (AuthDataService.authData.account)
      $scope.managers.push({
        id: AuthDataService.authData.account.id,
        name: AuthDataService.authData.account.name
      });
    if (account_id) {
      angular.forEach(AuthDataService.authData.accountsManager, function (account) {
        if (account.id == account_id) {
          angular.forEach(account.managed_to_me, function (value) {
            $scope.managers.push(value);
          });
        }
      });
    } else {
      if (AuthDataService.authData.account) {
        angular.forEach(AuthDataService.authData.account.managed_to_me, function (value) {
          $scope.managers.push(value);
        });
      }
    }
  };

  $scope.onFilterChange = function() {
    var defer = $q.defer();
    $scope.loading = true;
    PropertyService.getlist({
      account: ($scope.showFilter('account') && $scope.account) ? $scope.account : null,
      managed_by: ($scope.showFilter('managed_by') && $scope.managed_by) ? $scope.managed_by : null,
      portfolio__id: ($scope.showFilter('portfolio') && $scope.portfolio) ? $scope.portfolio : null,
      group: ($scope.showFilter('group') && $scope.group) ? $scope.group : null,
      disable_pagination: true,
      essential: true,
      not_empty: true
    }).then(function (list) {
      var results = list.results ? list.results : list;
      if (results.length === 0) {
        $scope.properties = [];
      } else {
        $scope.properties = results;
      }
      $scope.loading = false;
      defer.resolve();
    }, function (error) {
      $scope.loading = false;
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.onAccountChanged = function () {
    if ($scope.filter_by === 'group') {
      var defer = $q.defer();
      PropertyGroupService.getlist({
        account: ($scope.showFilter('account') && $scope.account) ? $scope.account : null,
        managed_by: ($scope.showFilter('managed_by') && $scope.managed_by) ? $scope.managed_by : null,
        disable_pagination: true,
        essential: true,
        not_empty: true
      }).then(function (list) {
        if (list.length === 0) {
          $scope.groups = [];
        } else {
          $scope.groups = list.results ? list.results : list;
        }
        $scope.onGroupChanged().then(function() {
          defer.resolve();
        }, function (error) {
          defer.reject(error);
        });
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }
    else if ($scope.filter_by === 'portfolio') {
      return $scope.onGroupChanged();
    }
    else {
      return $scope.onFilterChange();
    }
  };

  $scope.onGroupChanged = function () {
    if ($scope.filter_by === 'portfolio') {
      var defer = $q.defer();
      PortfolioService.getlist({
        account: ($scope.showFilter('account') && $scope.account) ? $scope.account : null,
        managed_by: ($scope.showFilter('managed_by') && $scope.managed_by) ? $scope.managed_by : null,
        group: ($scope.showFilter('group') && $scope.group) ? $scope.group : null,
        disable_pagination: true,
        essential: true,
        not_empty: true
      }).then(function (list) {
        if (list.length === 0) {
          $scope.portfolios = [];
        } else {
          $scope.portfolios = list.results ? list.results : list;
        }
        $scope.onFilterChange().then(function() {
          defer.resolve();
        }, function(error) {
          defer.reject(error);
        });
      }, function (error) {
        defer.reject(error);
      });
      return defer.promise;
    }
    else {
      return $scope.onFilterChange();
    }
  };

  $scope.onPortfolioChanged = function () {
    return $scope.onFilterChange();
  };

  $scope.showFilter = function (filter) {
    switch (filter) {
      case 'account':
        return _.contains(['portfolio', 'group'], $scope.filter_by)  && (FilterService.accounts.length > 1);
      case 'managed_by':
        return ($scope.filter_by === 'managed_by') && ($scope.managers.length > 1);
      case 'group':
        return ($scope.filter_by === 'group') && (FilterService.groups.length > 1);
      case 'portfolio':
        return ($scope.filter_by === 'portfolio') && (FilterService.portfolios.length > 1);
      default:
        return false;
    }
  };

  $scope.disable = function(filter) {
    var disable = true;
    switch (filter) {
      case 'group':
      case 'portfolio':
        disable = $scope.accounts.length > 1 && isNull($scope.account);
        break;
      case 'property':
        if ($scope.filter_by === 'group') {
          disable = ($scope.accounts.length > 1 && isNull($scope.account)) || isNull($scope.group);
        }
        else if ($scope.filter_by === 'portfolio') {
          disable = ($scope.accounts.length > 1 && isNull($scope.account)) || isNull($scope.portfolio);
        }
        else if ($scope.filter_by === 'managed_by') {
          disable = isNull($scope.managed_by);
        }
        else {
          disable = false;
        }
        break;
    }
    return disable;
  };

  $scope.showList = function() {
    switch ($scope.filter_by) {
      case 'group':
      case 'portfolio':
      case 'managed_by':
        return !$scope.disable('property') && !$scope.loading;
      default:
        return true;
    }
  };

  $scope.$watch('account', function (newValue, oldValue) {
    if ((newValue !== oldValue) && $scope.initialized) {
      $scope.onAccountChanged().then(function () {
        $scope.initManagers(newValue);
      });
    }
  });

  $scope.$watch('group', function (newValue, oldValue) {
    if ((newValue !== oldValue) && $scope.initialized) {
      $scope.onGroupChanged();
    }
  });

  $scope.$watch('managed_by', function (newValue, oldValue) {
    if ((newValue !== oldValue) && $scope.initialized) {
      $scope.onAccountChanged();
    }
  });

  $scope.$watch('portfolio', function (newValue, oldValue) {
    if ((newValue !== oldValue) && $scope.initialized) {
      if (!$scope.no_event) {
        $scope.onPortfolioChanged();
      }
      $scope.no_event = false;
    }
  });

  $scope.$watch('filter_by', function (newValue, oldValue) {
    if ((newValue !== oldValue) && $scope.initialized) {
      switch (newValue) {
        case 'name':
          $scope.account = undefined;
          $scope.managed_by = undefined;
          $scope.group = undefined;
          $scope.portfolio = undefined;
          $scope.property = undefined;
          break;
        case 'portfolio':
          $scope.managed_by = undefined;
          $scope.group = undefined;
          break;
        case 'group':
          $scope.managed_by = undefined;
          $scope.portfolio = undefined;
          break;
        case 'managed_by':
          $scope.account = undefined;
          $scope.group = undefined;
          $scope.portfolio = undefined;
          break;
      }
    }
  });

  $scope.reset = function () {
    $scope.accounts = angular.copy(FilterService.accounts);
    $scope.portfolios = angular.copy(FilterService.portfolios);
    $scope.properties = angular.copy(FilterService.properties);
    $scope.groups = angular.copy(FilterService.groups);
    $scope.managers = angular.copy(FilterService.managers);
  };

  $scope.init = function () {
    $scope.reset();
    $scope.filters_by = [{id:'name', name:'By Name'}];
    if ($scope.portfolios.length > 1) {
      $scope.filters_by.push({id:'portfolio', name:'By Portfolio'});
    }
    if (FilterService.groups.length > 1) {
      $scope.filters_by.push({id:'group', name:'By Group'});
    }
    if ($scope.managers.length > 1) {
      $scope.filters_by.push({id:'managed_by', name:'By Management Company'});
    }
    $scope.initialized = true;
  };

  if (FilterService.initialized) {
    $scope.init();
  } else {
    $scope.$on('filter-service:initiated', $scope.init);
  }

  $scope.change = function() {
    if (!$scope.multiple) {
      $scope.submit();
    }
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      return;
    }
    $scope.confirm($scope.property);
  };

};

app.controller('PropertyDialogController', ['$scope', '$rootScope', '$q', 'FilterService', 'AuthDataService',
  'PortfolioService', 'PropertyService', 'PropertyGroupService', PropertyDialogController
]);
app.directive('propertyDialogSelector', ['ngDialog', 'FilterService', 'PropertyService', '$q', PropertyDialogSelector]);
